module.exports = __webpack_public_path__ + "static/media/ikon.58939e24.jpg";